import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormControlLabel, Paper, Radio, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, styled } from '@mui/material';
import { YESorNO } from '@/types';
import styles from './ModelSeriesBlockedSelector.module.scss';

interface ModelSeriesBlockedSelectorProps {
  disabled?: boolean;
  onChange?: (value: boolean) => void;
  hasError?: boolean;
  blockVehicles: boolean | undefined;
}

const CustomPaper = styled(Paper)(() => ({
  boxShadow: '0px 0px 10px 1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)',
}));

const ModelSeriesBlockedSelector: React.FC<ModelSeriesBlockedSelectorProps> = (props) => {
  const { disabled = false, onChange, hasError = false, blockVehicles } = props;

  const { t } = useTranslation();

  return (
    <TableContainer component={CustomPaper}>
      <Table size="small" className={hasError ? styles.MSBlockedTableWarning : ''}>
        <TableHead>
          <TableRow>
            <TableCell align="center">{t('buttonsHeader.blockedCars')}</TableCell>
            <TableCell align="center">{t('buttonsHeader.noBlockedCars')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell align="center">
              <FormControlLabel
                disabled={disabled}
                value="YES"
                control={<Radio size="small" checked={blockVehicles === true} onChange={onChange ? () => onChange(true) : undefined} />}
                label=""
              />
            </TableCell>
            <TableCell align="center">
              <FormControlLabel
                disabled={disabled}
                value="NO"
                control={<Radio size="small" checked={blockVehicles === false} onChange={onChange ? () => onChange(false) : undefined} />}
                label=""
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ModelSeriesBlockedSelector;
